export const JOBS_ANALYTICS_EVENTS = {
  jobPostCreated: "jobs job post created",
  jobPostUpdated: "jobs job post updated"
} as const;

export type JobsAnalyticsSource = "jobs_create" | "jobs_edit";

export type JobsAnalyticsData = {
  source: JobsAnalyticsSource;
  success: boolean;
  jobPostId?: string;
  action?: string;
  isDraft?: boolean;
  sentForReview?: boolean;
  stage?: string;
};

export function getJobsAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: JobsAnalyticsSource;
  success?: boolean;
} & Omit<JobsAnalyticsData, "source" | "success">): JobsAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
